import type { ReactElement } from "react";
import type { Ordner } from "@kundeninfo/api-client";
import { buildFolderTree } from "./folderTree.js";
import type { FolderNode } from "./folderTree.js";
import { DOCUMENT_FILE_TEXT as T } from "./texts.js";
import "./folderTree.css";

/**
 * Der Ordnerbaum des Kunden als Auswahl (Panel „Vorhandene Datei verknüpfen“ und „Anderen Ort wählen“ beim Hochladen).
 * `rootLabel` beschriftet die Wahl „kein Ordner“ (`null`); ohne Angabe gibt es sie nicht. Dieselbe Gestalt wie der Baum
 * im Kundenreiter (`folderTree.css`).
 */
export function FolderTreeSelect(p: {
  folders: readonly Ordner[]; selected: string | null; rootLabel?: string; onSelect: (id: string | null) => void;
}): ReactElement {
  const item = (id: string | null, name: string, children: FolderNode[]): ReactElement => (
    <li key={id ?? ""} className="folder-tree__item">
      <button type="button" className="folder-tree__folder" aria-pressed={p.selected === id} onClick={() => p.onSelect(id)}>
        {name}
      </button>
      {children.length > 0 && (
        <ul className="folder-tree folder-tree--children">
          {children.map((c) => item(c.folder.id, c.folder.name, c.children))}
        </ul>
      )}
    </li>
  );
  return (
    <ul className="folder-tree" aria-label={T.columnFolder}>
      {p.rootLabel !== undefined && item(null, p.rootLabel, [])}
      {buildFolderTree(p.folders).map((n) => item(n.folder.id, n.folder.name, n.children))}
    </ul>
  );
}
